<app-form-tagbase
    (onValidate)="validate($event)"
    (onCancel)="cancel()"
>
</app-form-tagbase>

